import { Button, Drawer, Flex, Image, Page, Typography } from "@payping/web-components";
import { SubLayout } from "@/components/SubLayout";
import { useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import { Close, DownloadOutlined } from "@payping/icons";
import { DashboardRoutes } from "@/router";
import { buildUrl } from "@payping/utilities-shared/url";
import { closeId } from "@/assets/googleTrackIds";
import { URLS } from "@payping/utilities-shared/consts";

const GetAccessHelp = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  return (
    <Drawer
      title={<Typography.Text>{t("digitalAccount.termsAndCondition.samanBankAccountOpeningForm")}</Typography.Text>}
      open={true}
      closable={false}
      height={"100%"}
      placement={"bottom"}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(DashboardRoutes.digitalAccount.saman.access.getInfo?.url);
          }}
          data-google-track={closeId}
        />
      }
    >
      <Page>
        <SubLayout>
          <Flex vertical gap={16}>
            <div className="tw:flex! tw:justify-center!">
              <Flex vertical className={"tw:max-w-full"} gap={16}>
                <Typography.Title className={"tw:md:whitespace-pre-line"} level={4}>
                  {t("digitalAccount.samanGetAccessHelp.title")}
                </Typography.Title>
                <Typography.Text className={"tw:md:whitespace-pre-line"} strong>
                  {t("digitalAccount.samanGetAccessHelp.desc1")}
                </Typography.Text>
                <Button
                  target={"_blank"}
                  href={`${buildUrl(URLS.STORAGE_URL, "digitalAccount/documents/agreementDigitalAccountSaman.pdf").toString()}`}
                  className={"tw:w-fit"}
                  type={"default"}
                  icon={<DownloadOutlined width={14} height={14} />}
                >
                  {t("digitalAccount.samanBankOpeningGuid.getForm")}
                </Button>
                <Typography.Title className={"tw:md:whitespace-pre-line"} level={5}>
                  {t("digitalAccount.samanGetAccessHelp.getUserPassWebService")}
                </Typography.Title>
                <Typography.Text type={"secondary"} className={"tw:md:whitespace-pre-line"} strong>
                  {t("digitalAccount.samanGetAccessHelp.desc2")}
                </Typography.Text>
                <Typography.Text strong>{t("digitalAccount.samanGetAccessHelp.theFirstSheet")}</Typography.Text>
                <Image
                  src={`${URLS.STORAGE_URL}/img/UserPass.png`}
                  preview={false}
                  className={"tw:w-max-[400px] tw:h-max-[220px]"}
                />
                <Typography.Title className={"tw:md:whitespace-pre-line"} level={5}>
                  {t("digitalAccount.samanGetAccessHelp.getUserPassWebService")}
                </Typography.Title>
                <Typography.Text type={"secondary"} className={"tw:md:whitespace-pre-line"} strong>
                  {t("digitalAccount.samanGetAccessHelp.desc3")}
                </Typography.Text>
                <Typography.Text strong>{t("digitalAccount.samanGetAccessHelp.theSecondSheet")}</Typography.Text>
                <Image
                  src={`${URLS.STORAGE_URL}/img/SecretKey-ChannelName.png`}
                  preview={false}
                  className={"tw:w-max-[400px] tw:h-max-[220px]"}
                />
                <Typography.Title className={"tw:md:whitespace-pre-line"} level={5}>
                  {t("digitalAccount.samanGetAccessHelp.settingUserName")}
                </Typography.Title>
                <Typography.Text type={"secondary"} className={"tw:md:whitespace-pre-line"} strong>
                  {t("digitalAccount.samanGetAccessHelp.desc4")}
                </Typography.Text>
              </Flex>
            </div>
          </Flex>
        </SubLayout>
      </Page>
    </Drawer>
  );
};

export default GetAccessHelp;
